import React, { useEffect, useRef, useCallback, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useLocation } from "react-router-dom"
import PropTypes, { element } from "prop-types"

// //Import Scrollbar
import SimpleBar from "simplebar-react"

// MetisMenu
import MetisMenu from "metismenujs"
import withRouter from "components/Common/withRouter"
import { Link } from "react-router-dom"

//i18n
import { withTranslation } from "react-i18next"
import { getMainPrivillage } from "store/actions"
import { privilegePageId } from "common/privilege"

const SidebarContent = props => {
  const [mainPrivillage, setMainPrivillage] = useState([])
  const mainPrivillageData = useSelector(state => state.privillage.mainPrivillageData)
  const { userDataAll: userDataAll } = useSelector(state => state.loginUser)
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(getMainPrivillage(JSON.parse(localStorage.getItem("authUser")).pkEmpId))
  }, [])

  useEffect(() => {
    setMainPrivillage(mainPrivillageData)
  }, [mainPrivillageData])

  const ref = useRef()
  const activateParentDropdown = useCallback(item => {
    item.classList.add("active")
    const parent = item.parentElement
    const parent2El = parent.childNodes[1]

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show")
    }

    if (parent) {
      parent.classList.add("mm-active")
      const parent2 = parent.parentElement

      if (parent2) {
        parent2.classList.add("mm-show") // ul tag

        const parent3 = parent2.parentElement // li tag

        if (parent3) {
          parent3.classList.add("mm-active") // li
          parent3.childNodes[0].classList.add("mm-active") //a
          const parent4 = parent3.parentElement // ul
          if (parent4) {
            parent4.classList.add("mm-show") // ul
            const parent5 = parent4.parentElement
            if (parent5) {
              parent5.classList.add("mm-show") // li
              parent5.childNodes[0].classList.add("mm-active") // a tag
            }
          }
        }
      }
      scrollElement(item)
      return false
    }
    scrollElement(item)
    return false
  }, [])

  const removeActivation = items => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i]
      const parent = items[i].parentElement

      if (item && item.classList.contains("active")) {
        item.classList.remove("active")
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.lenght && parent.childNodes[1]
            ? parent.childNodes[1]
            : null
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show")
        }

        parent.classList.remove("mm-active")
        const parent2 = parent.parentElement

        if (parent2) {
          parent2.classList.remove("mm-show")

          const parent3 = parent2.parentElement
          if (parent3) {
            parent3.classList.remove("mm-active") // li
            parent3.childNodes[0].classList.remove("mm-active")

            const parent4 = parent3.parentElement // ul
            if (parent4) {
              parent4.classList.remove("mm-show") // ul
              const parent5 = parent4.parentElement
              if (parent5) {
                parent5.classList.remove("mm-show") // li
                parent5.childNodes[0].classList.remove("mm-active") // a tag
              }
            }
          }
        }
      }
    }
  }

  const path = useLocation()
  const activeMenu = useCallback(() => {
    const pathName = path.pathname
    let matchingMenuItem = null
    const ul = document.getElementById("side-menu")
    const items = ul.getElementsByTagName("a")
    removeActivation(items)

    for (let i = 0; i < items.length; ++i) {
      if (pathName === items[i].pathname) {
        matchingMenuItem = items[i]
        break
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem)
    }
  }, [path.pathname, activateParentDropdown])

  useEffect(() => {
    ref.current.recalculate()
  }, [])

  useEffect(() => {
    new MetisMenu("#side-menu")
    activeMenu()
  }, [])

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" })
    activeMenu()
  }, [activeMenu])

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300
      }
    }
  }

  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            {mainPrivillage.some((privilege) => privilege.PK_Page_ID === privilegePageId.dashboard) && (
              <li>
                <Link to="/dashboard">
                  <i className="bx bxs-dashboard"></i>
                  <span>Dashboard {props.menuOpen}</span>
                </Link>
              </li>
            )}

            {mainPrivillage.some((privilege) => privilege.PK_Page_ID === privilegePageId.products) && (
              <li>
                <Link to="/products">
                  <i className="bx bxs-cart"></i>
                  <span>
                    {props.t("Products")} {props.menuOpen}
                  </span>
                </Link>
              </li>
            )}
            {mainPrivillage.some((privilege) => privilege.PK_Page_ID === privilegePageId.purchase) && <li>
              <Link to="/purchase">
                <i className="bx bxs-purchase-tag-alt"></i>
                <span>
                  {props.t("Purchase")} {props.menuOpen}
                </span>
              </Link>
            </li>}
            {mainPrivillage.some((privilege) => privilege.PK_Page_ID === privilegePageId.expenses) && <li>
              <Link to="/expenses">
                <i className="bx bx-dollar"></i>
                <span>
                  {props.t("Expenses")} {props.menuOpen}
                </span>
              </Link>
            </li>}

            {mainPrivillage.some((privilege) => privilege.PK_Page_ID === privilegePageId.mainTransfer) && <li>
              <Link to="/#" className="has-arrow">
                <i className="bx bx-transfer-alt"></i>
                <span>{props.t("transfer")}</span>
              </Link>
              <ul className="sub-menu">
                {mainPrivillage.some((privilege) => privilege.PK_Page_ID === privilegePageId.safeTransfer) && <li>
                  <Link to="/safe-transfer">{props.t("Safe Transfer")}</Link>
                </li>}
                {mainPrivillage.some((privilege) => privilege.PK_Page_ID === privilegePageId.stockTransfer) && <li>
                  <Link to="/stock-transfer">{props.t("stockTransfer")}</Link>
                </li>}
              </ul>
            </li>}

            {mainPrivillage.some((privilege) => privilege.PK_Page_ID === privilegePageId.component) && <li>
              <Link to="/component">
                <i className="mdi mdi-apple-keyboard-shift"></i>
                <span>{props.t("Component")}</span>
              </Link>
            </li>}

            {mainPrivillage.some((privilege) => privilege.PK_Page_ID === privilegePageId.mainShift) && <li>
              <Link to="/#" className="has-arrow">
                <i className="bx bxs-collection"></i>
                <span>{props.t("End Shift")}</span>
              </Link>
              <ul className="sub-menu">
                {mainPrivillage.some((privilege) => privilege.PK_Page_ID === privilegePageId.endShift) && <li>
                  <Link to="/end-shift">{props.t("End Shift")}</Link>
                </li>}
                {mainPrivillage.some((privilege) => privilege.PK_Page_ID === privilegePageId.endShiftReport) && <li>
                  <Link to="/end-shift-report">
                    {props.t("End Shift Report")}
                  </Link>
                </li>}
              </ul>
            </li>}

            {mainPrivillage.some((privilege) => privilege.PK_Page_ID === privilegePageId.mainReport) && <li>
              <Link to="/#" className="has-arrow">
                <i className="bx bxs-report"></i>
                <span>{props.t("Reports")}</span>
              </Link>
              <ul className="sub-menu">
                {mainPrivillage.some((privilege) => privilege.PK_Page_ID === privilegePageId.stockBalance) && <li>
                  <Link to="/reports/stock-balance">
                    {props.t("Stock Balance")}
                  </Link>
                </li>}
                {mainPrivillage.some((privilege) => privilege.PK_Page_ID === privilegePageId.safeBalance) && <li>
                  <Link to="/reports/safe-balance">
                    {props.t("Safe Balance")}
                  </Link>
                </li>}
                {mainPrivillage.some((privilege) => privilege.PK_Page_ID === privilegePageId.supplierPayment) && <li>
                  <Link to="/reports/supplier-payment">
                    {props.t("Supplier Payment")}
                  </Link>
                </li>}
                {mainPrivillage.some((privilege) => privilege.PK_Page_ID === privilegePageId.netProfit) && <li>
                  <Link to="/reports/net-profit">{props.t("Net Profit")}</Link>
                </li>}
                {mainPrivillage.some((privilege) => privilege.PK_Page_ID === privilegePageId.monthlyReport) && <li>
                  <Link to="/reports/monthly-report">
                    {props.t("Monthly Report")}
                  </Link>
                </li>}
                {mainPrivillage.some((privilege) => privilege.PK_Page_ID === privilegePageId.dailyReport) && <li>
                  <Link to="/reports/daily-report">
                    {props.t("Daily Report")}
                  </Link>
                </li>}
                {mainPrivillage.some((privilege) => privilege.PK_Page_ID === privilegePageId.supplierAccount) && <li>
                  <Link to="/reports/supplier-account">
                    {props.t("Supplier Account")}
                  </Link>
                </li>}
                {mainPrivillage.some((privilege) => privilege.PK_Page_ID === privilegePageId.expenseReport) && <li>
                  <Link to="/reports/expense-report">
                    {props.t("Expense Report")}
                  </Link>
                </li>}
                {mainPrivillage.some((privilege) => privilege.PK_Page_ID === privilegePageId.itemsSalesReport) && <li>
                  <Link to="/reports/items-sales-report">
                    {props.t("Items Sales Reports")}
                  </Link>
                </li>}
                {mainPrivillage.some((privilege) => privilege.PK_Page_ID === privilegePageId.shiftReport) && <li>
                  <Link to="/reports/shift-report">
                    {props.t("Shift Reports")}
                  </Link>
                </li>}
                {mainPrivillage.some((privilege) => privilege.PK_Page_ID === privilegePageId.safeTransferReport) && <li>
                  <Link
                    to="/reports/safe-transfer-report"
                    className="dropdown-item dropdown-toggle arrow-none"
                  >
                    {props.t("Safe Transfer Report")}
                  </Link>
                </li>}
                {mainPrivillage.some((privilege) => privilege.PK_Page_ID === privilegePageId.stockTransferReport) && <li>
                  <Link
                    to="/reports/stock-transfer-report"
                    className="dropdown-item dropdown-toggle arrow-none"
                  >
                    {props.t("Stock Transfer Report")}
                  </Link>
                </li>}
              </ul>
            </li>}
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  )
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(SidebarContent))
